import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

// Single source of truth for which right-side panel is open. Lives in
// the `?panel=<id>` search param so panels are bookmarkable, the
// browser back button closes them, and a refresh restores state.
//
// Valid panel ids are the keys of the panel registry (see RightPanelHost).
export type PanelId =
  | "wallet"
  | "tutor"
  | "memory"
  | "library"
  | "bugs"
  | "hackathon"
  | "squads"
  | "leaders"
  | "settings";

export function useRightPanel() {
  const [params, setParams] = useSearchParams();
  const activePanel = params.get("panel") as PanelId | null;

  const openPanel = useCallback(
    (id: PanelId) => {
      setParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set("panel", id);
          return next;
        },
        { replace: false },
      );
    },
    [setParams],
  );

  const closePanel = useCallback(() => {
    setParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete("panel");
        return next;
      },
      { replace: false },
    );
  }, [setParams]);

  return { activePanel, openPanel, closePanel };
}